import { useEffect, useState } from "react";
import arrowRight from "../assets/arrowRight.png";
import arrowRightOrange from "../assets/arrowRightOrange.png";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const DeliveryTimeLine = () => {
  const [pedidos, setPedidos] = useState([]);
  const openModal = () => {
    alert("clicou");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/order-load/last-order");
        setPedidos(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);

  const year = new Date().getFullYear();
  const navigate = useNavigate();
  const handleNavigateToCargas = () => {
    navigate("/cargas");
  };
  const handleNavigateToDetailsCargas = (id, index) => {
    navigate(`/cargas/${id}/detalhes/${index}`);
  };

  return (
    <div className=" md:col-span-2 lg:col-span-1 xl:col-span-1 bg-[#F2F2F2] rounded-md p-4  md:ml-0 md:mt-2 lg:mt-0 xl:ml-4 ">
      <div
        className="flex justify-between cursor-pointer"
        onClick={handleNavigateToCargas}
      >
        <h2 className="">
          <span className="font-bold text-boldGray opacity-70 text-base xl:text-xl">
            Histórico de cargas
          </span>
          <br />
        </h2>
        <div className="flex items-center">
          <img src={arrowRight} alt="" />
        </div>
      </div>
      <div className="mt-8">
        <div
          className={`h-[500px] overflow-y-auto custom-scrollbar ${
            pedidos.length > 7 && "pr-4"
          }`}
        >
          {pedidos.map((item, index) => (
            <div
              key={index}
              className={`border xl:px-2 xl:py-3.5 lg:px-1 lg:py-2 md:py-3 md:px-2 rounded flex items-center justify-between bg-[#E7E7E7] text-boldGray opacity-90 cursor-pointer ${
                index !== pedidos.length - 1 ? "mb-2" : ""
              }`}
              onClick={() => handleNavigateToDetailsCargas(item.id, index + 1)}
            >
              <p>
                <span className="text-[#FF9533] font-bold lg:text-xs xl:text-base">
                  {`C00${index + 1}-${year}`}
                </span>
              </p>
              <p className="text-center text-xs">
                <span className="font-bold uppercase">
                  Pedido {item.status}
                </span>{" "}
                <br />
                {new Date(item.createdAt).toLocaleDateString("pt-BR")}
              </p>
              <p className="text-center text-xs">
                <span className="font-bold uppercase text-center text-xs">
                  Previsão{" "}
                </span>{" "}
                <br />
                {new Date(item.loading_date).toLocaleDateString("pt-BR")}
              </p>
              <div className="flex items-center">
                <img src={arrowRightOrange} alt="" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DeliveryTimeLine;
